import { NumberFormat }	from "@geotoura/shared/numberFormat";

export const numberFormat:NumberFormat	= NumberFormat.simple("it-IT");
